var link_viewer_default = {
  "fontElementMap": "Gc5jR",
  "link": "G2Vds",
  "linkInEditor": "Dtfut",
  "linkInViewer": "C0SQ-",
  "toolbarUrlContainer": "CLGd0",
  "toolbarUrl": "TeIBR",
  "toolbarUrlAnchor": "AmB9O"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
